import React from "react";

const contestAreas = [
  {
    title: "🎒 School Students",
    daily: [
      "Estimate time required to complete today's homework",
      "Estimate time needed to memorize a poem"
    ],
    weekly: [
      "Estimate time required to prepare a science project",
      "Estimate time required to revise a full chapter"
    ],
    monthly: [
      "Estimate number of days required to finish a library book or exam preparation"
    ]
  },
  {
    title: "🎓 Senior Students",
    daily: [
      "Estimate time required to complete a coding problem",
      "Estimate time required to finish a practice test"
    ],
    weekly: [
      "Estimate time needed to prepare a presentation",
      "Estimate time required to learn a new software tool"
    ],
    monthly: [
      "Estimate duration required to complete a semester project"
    ]
  },
  {
    title: "💼 Professionals",
    daily: [
      "Estimate time required to finish a report",
      "Estimate time required to resolve a bug or issue"
    ],
    weekly: [
      "Estimate time required for feature development",
      "Estimate duration of a marketing campaign"
    ],
    monthly: [
      "Estimate delivery time for a major project"
    ]
  },
  {
    title: "🏠 Home / Personal Life",
    daily: [
      "Estimate time required to cook dinner",
      "Estimate time required to finish grocery shopping"
    ],
    weekly: [
      "Estimate time required to clean the house",
      "Estimate time required to organize a family event"
    ],
    monthly: [
      "Estimate preparation time for festival or travel planning"
    ]
  },
  {
    title: "🏭 MSME Businesses",
    daily: [
      "Estimate time required to manufacture a product batch",
      "Estimate time required to complete a customer order"
    ],
    weekly: [
      "Estimate machine maintenance duration",
      "Estimate raw material procurement time"
    ],
    monthly: [
      "Estimate time required to launch a new product"
    ]
  },
  {
    title: "🌾 Agriculture",
    daily: [
      "Estimate time required for irrigation cycle",
      "Estimate time required for crop inspection"
    ],
    weekly: [
      "Estimate fertilizer application time",
      "Estimate pest control activity duration"
    ],
    monthly: [
      "Estimate crop harvesting duration"
    ]
  }
];

const ThreePContest = () => {
  return (
    <div className="bg-black text-white [&_p]:text-white min-h-screen p-4 mt-2">

      <div className="mx-auto">

        {/* Header */}

        <h1 className="text-lg lg:text-xl font-bold text-yellow-200 mb-2">
          🏆 Think5Whys 3P Estimation Contest
        </h1>

        <h1 className="text-xs lg:text-sm text-gray-200 mb-6">
          Daily • Weekly • Monthly Estimation Challenges
        </h1>

        <p className="text-xs lg:text-base mb-4">
          The Think5Whys Three-Point Estimation Contest helps people practice
          <span className="font-semibold"> estimation, probability thinking and realistic planning.</span>
          Participants estimate real-world tasks using Optimistic, Most-Likely
          and Pessimistic scenarios.
        </p>

        <p className="text-xs lg:text-base mb-6">
          Winners are selected based on the
          <span className="font-semibold"> closest estimate to the real outcome.</span>
        </p>

        {/* Rewards */}

        <div className="bg-gray-800 border border-gray-700 p-4 rounded-lg mb-8">

          <h3 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-3">
            💰 Contest Rewards
          </h3>

          <ul className="text-xs lg:text-base list-disc list-inside space-y-1 [&_li]:text-gray-100">
            <li>Daily Winner → ₹100 – ₹500</li>
            <li>Weekly Winner → ₹1000</li>
            <li>Monthly Winner → ₹5000 or Special Recognition</li>
          </ul>

        </div>


        {/* Contest Areas */}

        {contestAreas.map((area, index) => (
          <div key={index} className="mb-10">

            <h2 className="text-sm lg:text-xl font-semibold text-purple-300 mb-3">
              {area.title}
            </h2>

            {/* Daily */}

            <div className="mb-3">

              <h3 className="text-xs lg:text-base font-semibold text-green-300 mb-1">
                📅 Daily Challenge
              </h3>

              <ul className="list-disc list-inside text-xs lg:text-base space-y-1 text-gray-200">
                {area.daily.map((item, i) => (
                  <li className="text-gray-100" key={i}>{item}</li>
                ))}
              </ul>

            </div>

            {/* Weekly */}

            <div className="mb-3">

              <h3 className="text-xs lg:text-base font-semibold text-blue-300 mb-1">
                📆 Weekly Challenge
              </h3>

              <ul className="list-disc list-inside text-xs lg:text-base space-y-1 text-gray-200">
                {area.weekly.map((item, i) => (
                  <li className="text-gray-100" key={i}>{item}</li>
                ))}
              </ul>

            </div>

            {/* Monthly */}

            <div>

              <h3 className="text-xs lg:text-base font-semibold text-pink-300 mb-1">
                🗓 Monthly Lucky Winner
              </h3>

              <ul className="list-disc list-inside text-xs lg:text-base space-y-1 text-gray-200">
                {area.monthly.map((item, i) => (
                  <li className="text-gray-100" key={i}>{item}</li>
                ))}
              </ul>

            </div>

          </div>
        ))}


        {/* Leaderboard */}

        <div className="bg-gray-800 p-4 rounded-lg">

          <h3 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
            🧠 Think5Whys Estimation Ranks
          </h3>

          <ul className="text-xs lg:text-base list-disc list-inside space-y-1 [&_li]:text-gray-100">
            <li>🥉 Estimation Learner</li>
            <li>🥈 Estimation Pro</li>
            <li>🥇 Estimation Master</li>
          </ul>

        </div>

      </div>

    </div>
  );
};

export default ThreePContest;